import {
  entityLabelsEqual,
  getItemLabels,
  normalizeEntityLabelsArray,
} from './entityLabelFilter';

/** Labels shared by every item in the list (intersection). */
export function getSharedLabelsAmongItems(items, labelField = 'labels') {
  const labelLists = (items || []).map((item) => getItemLabels(item, labelField));
  if (labelLists.length === 0) return [];
  const [first, ...rest] = labelLists;
  return first.filter((label) => rest.every((labels) => labels.includes(label)));
}

/**
 * Apply the same label set to each selected item; skips unchanged rows.
 * @param {(item: object, labels: string[]) => Promise<void>} updateLabels
 */
export async function bulkApplyLabelsToItems({
  items,
  selectedIds,
  labels,
  getId,
  updateLabels,
  labelField = 'labels',
}) {
  const nextLabels = normalizeEntityLabelsArray(labels);
  const targets = (items || []).filter((item) => selectedIds.has(getId(item)));
  let updated = 0;
  let skipped = 0;
  const errors = [];

  for (const item of targets) {
    if (entityLabelsEqual(getItemLabels(item, labelField), nextLabels)) {
      skipped += 1;
      continue;
    }
    try {
      await updateLabels(item, nextLabels);
      updated += 1;
    } catch (err) {
      errors.push(err?.message || 'Failed to update labels');
    }
  }

  return { updated, skipped, errors, total: targets.length };
}
